module.exports = __webpack_public_path__ + "static/media/company.f260d7bc.svg";